var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"root"},[_c('Navbar',{attrs:{"user":_vm.user}}),_c('div',{staticClass:"root-body"},[_c('div',{staticClass:"page-wrapper"},[_c('router-view')],1),_c('Footer')],1),_c('OverlayLoader')],1)}
var staticRenderFns = []

export { render, staticRenderFns }